import { PLAN_IDS, normalizePlanId } from '../../../helpers/CustomerPlan';
import {
    contrastRgb,
    hslToRgb,
    hueFromString,
    intToHexString,
    parseColor,
} from '../../../helpers/Color';
import {
    defaultIdAttribute,
    defaultMergeStrategy,
    defaultProcessStrategy,
} from '../../../helpers/Normalizr';

import { schema } from 'normalizr';

export const entityName = 'subscriptions';
export const idAttribute = 'planId';

export const mergeStrategy = defaultMergeStrategy(idAttribute);
export const processStrategy = defaultProcessStrategy(idAttribute, data => {
    let { [idAttribute]: planId = data.id } = data;
    const normalizedPlanId = normalizePlanId(`${planId}`);

    const rgb = hslToRgb(hueFromString(`${normalizedPlanId || planId}`) / 360, 0.6, 0.9);
    const { color = intToHexString.apply(null, rgb) } = data;

    const isBusinessPlan = PLAN_IDS.BUSINESS === normalizedPlanId;

    const isBusinessPlusPlan = PLAN_IDS.BUSINESS_PLUS === normalizedPlanId;

    const isDeveloperPlan = PLAN_IDS.DEVELOPER === normalizedPlanId;

    const isEnterprisePlan = PLAN_IDS.ENTERPRISE === normalizedPlanId;

    return {
        isBusinessPlan,
        isBusinessPlusPlan,
        isDeveloperPlan,
        isEnterprisePlan,
        textColor: color && contrastRgb.apply(null, parseColor(color)) ? '#ffffff' : '#000000',
        color: color && `#${intToHexString.apply(null, parseColor(color))}`,
        ...data,
        normalizedPlanId,
    };
});

export default new schema.Entity(entityName, undefined, {
    idAttribute: defaultIdAttribute(idAttribute),
    mergeStrategy,
    processStrategy,
});
